import { SortDownIcon, SortUpIcon, SortIcon } from '@panwds/icons';
import { Tooltip } from '@panwds/react-ui';
import React from 'react';
import { useIntl } from 'react-intl';

function SortButton({ column }) {
    if (!column.canSort) {
        return null;
    }
    const { getSortByToggleProps, isSorted, isSortedDesc } = column;
    const active = !!isSorted;
    const color = active ? 'tw-text-blue-400' : 'tw-text-gray-400';
    const iconProps = {
        size: 'xs',
        className: `${color}`
    };
    const intl = useIntl();
    return (React.createElement(Tooltip, { label: "Toggle the sort direction of the column" }, React.createElement("button", { "aria-label": intl.formatMessage({
            defaultMessage: 'Sort column',
            id: 'Sn658F',
            description: 'Label for sorting a column'
        }), className: "tw-box-border tw-flex tw-items-center tw-border-none tw-mr-0 tw-mt-0 tw-mb-0 tw-p-0 tw-ml-2 focus:outline-none focus-visible:ring tw-bg-transparent tw-rounded tw-opacity-0 group-hover:tw-opacity-100 focus:tw-opacity-100", ...getSortByToggleProps(), title: undefined, type: "button" }, isSorted ? (isSortedDesc ? (React.createElement(SortDownIcon, { "aria-label": intl.formatMessage({
            defaultMessage: '{column} column sorted in ascending order',
            id: 'h7tHa/',
            description: 'Label for column sorted in ascending order'
        }, {
            column: column.id
        }), ...iconProps })) : (React.createElement(SortUpIcon, { "aria-label": intl.formatMessage({
            defaultMessage: '{column} column sorted in descending order',
            id: 'raQAOH',
            description: 'Label for column sorted in descending order'
        }, {
            column: column.id
        }), ...iconProps }))) : (React.createElement(SortIcon, { ...iconProps })))));
}

export { SortButton };
//# sourceMappingURL=SortButton.esm.js.map
